import { render, staticRenderFns } from "./LowStateTypeDashboardTable.vue?vue&type=template&id=88ea99e4&scoped=true"
import script from "./LowStateTypeDashboardTable.vue?vue&type=script&lang=js"
export * from "./LowStateTypeDashboardTable.vue?vue&type=script&lang=js"
import style0 from "./LowStateTypeDashboardTable.vue?vue&type=style&index=0&id=88ea99e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ea99e4",
  null
  
)

export default component.exports